<script lang="ts" module>
  /**
   * Icon toolbar 3D — dùng CHÍNH XÁC bộ PNG thiết kế (design/Web Viewer UI/icons/toolbar_icons),
   * đã tách nền trắng → trong suốt bằng flood-fill từ viền (giữ nguyên mặt khối trắng + vân gỗ),
   * autocrop + downscale cao 96px. Raster nhiều màu → KHÔNG đổi màu theo trạng thái; nút active
   * dùng nền xanh nhạt + viền (xem Toolbar.svelte) thay vì nhuộm trắng.
   */
  import material from '../assets/toolbar/material.png';
  import matedge from '../assets/toolbar/matedge.png';
  import projection from '../assets/toolbar/projection.png';
  import xray from '../assets/toolbar/xray.png';
  import wireframe from '../assets/toolbar/wireframe.png';
  import wireframeHidden from '../assets/toolbar/wireframe-hidden.png';
  import camPerspective from '../assets/toolbar/cam-perspective.png';
  import camFront from '../assets/toolbar/cam-front.png';
  import camLeft from '../assets/toolbar/cam-left.png';
  import camRight from '../assets/toolbar/cam-right.png';
  import camTop from '../assets/toolbar/cam-top.png';
  import openAll from '../assets/toolbar/open-all.png';
  import closeAll from '../assets/toolbar/close-all.png';
  import measure from '../assets/toolbar/measure.png';

  export type ToolIconName =
    | 'material'
    | 'matedge'
    | 'projection'
    | 'xray'
    | 'wireframe'
    | 'wireframe-hidden'
    | 'cam-perspective'
    | 'cam-front'
    | 'cam-left'
    | 'cam-right'
    | 'cam-top'
    | 'open-all'
    | 'close-all'
    | 'measure';

  const SRC: Record<ToolIconName, string> = {
    material,
    matedge,
    projection,
    xray,
    wireframe,
    'wireframe-hidden': wireframeHidden,
    'cam-perspective': camPerspective,
    'cam-front': camFront,
    'cam-left': camLeft,
    'cam-right': camRight,
    'cam-top': camTop,
    'open-all': openAll,
    'close-all': closeAll,
    measure,
  };
</script>

<script lang="ts">
  let { name, size = 22 }: { name: ToolIconName; size?: number } = $props();
</script>

<img class="ticon" src={SRC[name]} alt="" draggable="false" style="height:{size}px" />

<style>
  .ticon {
    width: auto;
    max-width: 200%; /* icon phối cảnh hơi rộng — cho phép rộng theo tỉ lệ, căn theo chiều cao */
    object-fit: contain;
    display: block;
    user-select: none;
    -webkit-user-drag: none;
  }
</style>
